export default "__VITE_ASSET__DYEbQQrT__"